import React from "react";
import Header from '../components/header';
import Breadcrumb from "../components/Breadcrumb";
import WorkflowPlanOrder from "../components/workflowPlanOrder";
import Footer from "../components/footer";

const breadcrumbPaths = [
  { label: "Home", href: "/dashboard" },
  { label: "Produktionsplannung", href: "/workflow-planning" },
];

const WorkflowPlan = () => {
  
  return (
    <div>
      <Header />
      <div className="mx-auto 2xl:w-fill lg:w-[70%] w-4/5 py-16 pt-28 2xl:pt-36
      before:content-[''] before:bottom-0 before:right-0 before:w-[200px] before:h-[220px] before:bg-cover before:bg-right-bottom before:bg-no-repeat before:fixed before:bg-[url('./assets/images/schreiber-right.svg')] before:hidden lg:before:block before:-z-10
      after:content-[''] after:bottom-0 after:left-0 after:w-[200px] after:h-[220px] after:bg-cover after:bg-left-bottom after:bg-no-repeat after:fixed after:bg-[url('./assets/images/schreiber-left.svg')] after:hidden lg:after:block after:-z-10
      ">
        <Breadcrumb paths={breadcrumbPaths} />
        <WorkflowPlanOrder />
      </div>
      <div className="relative w-full"> <Footer /> </div>
    </div>
  );
};

export default WorkflowPlan;
